import { __awaiter, __generator } from "tslib";
import { getFileTypeFromFileName } from '@office-start/file-utility';
import { UploadErrorType } from '@office-start/upload-types';
import { executeLargeUploadFlow } from './executeLargeUploadFlow';
import { executeSimpleRetryUploadFlow } from './executeSimpleRetryUploadFlow';
import { executeSimpleUploadFlow } from './executeSimpleUploadFlow';
var MAX_RETRY_COUNT = 3;
export var executeUploadFlow = function (_a) {
    var componentContext = _a.componentContext, featureGates = _a.featureGates, fileUploadState = _a.fileUploadState, graphXhrOptions = _a.graphXhrOptions, updateFileUploadState = _a.updateFileUploadState, uploadConfig = _a.uploadConfig;
    return __awaiter(void 0, void 0, void 0, function () {
        var fileType, isSmallFile, uploadFlow;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            fileType = ((_b = fileUploadState.file) === null || _b === void 0 ? void 0 : _b.name) &&
                getFileTypeFromFileName(fileUploadState.file.name);
            if (!fileType || !(uploadConfig === null || uploadConfig === void 0 ? void 0 : uploadConfig.uploadFileTypes.has(fileType))) {
                return [2 /*return*/, Promise.reject(UploadErrorType.UnsupportedType)];
            }
            fileUploadState.retries = MAX_RETRY_COUNT;
            isSmallFile = ((_c = fileUploadState === null || fileUploadState === void 0 ? void 0 : fileUploadState.file) === null || _c === void 0 ? void 0 : _c.size)
                ? fileUploadState.file.size < uploadConfig.simpleUploadMaxSize
                : true;
            uploadFlow = isSmallFile
                ? ((_e = (_d = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _d === void 0 ? void 0 : _d.uploadRetryGates) === null || _e === void 0 ? void 0 : _e.uploadRetryEnabled)
                    ? executeSimpleRetryUploadFlow({
                        fileUploadState: fileUploadState,
                        updateFileUploadState: updateFileUploadState,
                        graphXhrOptions: graphXhrOptions,
                        componentContext: componentContext,
                    })
                    : executeSimpleUploadFlow({
                        fileUploadState: fileUploadState,
                        updateFileUploadState: updateFileUploadState,
                        graphXhrOptions: graphXhrOptions,
                        componentContext: componentContext,
                    })
                : executeLargeUploadFlow({
                    fileUploadState: fileUploadState,
                    updateFileUploadState: updateFileUploadState,
                    graphXhrOptions: graphXhrOptions,
                    uploadConfig: uploadConfig,
                    componentContext: componentContext,
                });
            return [2 /*return*/, uploadFlow];
        });
    });
};
//# sourceMappingURL=executeUploadFlow.js.map